import type { Car } from "@views/Upholstery/types"
import { isPdmStructureV2Enabled } from "../helpers/flags/isPdmStructureV2Enabled"
import { usePdmVehicleCatalogStore } from "../store/pdm-vehicle-catalog-store"

/** Picker list source — PDM catalog when V2 flag on, SSR Dato list otherwise. */
export function usePickerCars(datoCars: Car[]) {
  const isV2 = isPdmStructureV2Enabled()
  const pickerCars = usePdmVehicleCatalogStore((s) => s.pickerCars)
  const loading = usePdmVehicleCatalogStore((s) => s.loading)
  const error = usePdmVehicleCatalogStore((s) => s.error)

  if (!isV2) {
    return {
      cars: datoCars,
      loading: false,
      error: null,
      source: "dato" as const,
    }
  }

  return {
    cars: pickerCars,
    loading: loading && pickerCars.length === 0,
    error: pickerCars.length === 0 ? error : null,
    source: "pdm" as const,
  }
}
